
const BASE_URL: string = '/sign-out';

/**
 * 
 */
 export const SIGN_OUT_PATH = {

  SIGN_OUT: BASE_URL,
}